import React, { FunctionComponent } from 'react'
import Box from '@material-ui/core/Box'
import { CustomerNotificationExclusionsProvider } from 'CustomerNotificationExclusions/CustomerNotificationExclusionsProvider'
import Message, { MessageProvider } from 'components/elements/Message'
import Toolbar from 'CustomerNotificationExclusions/partials/Toolbar'
import List from 'CustomerNotificationExclusions/partials/List'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const CustomerNotificationExclusions: FunctionComponent<AllProps> = ({}) => {
  return (
    <Box p={1.5}>
      <CustomerNotificationExclusionsProvider>
        <MessageProvider>
          <Toolbar />
          <List />
          <Message />
        </MessageProvider>
      </CustomerNotificationExclusionsProvider>
    </Box>
  )
}

export default CustomerNotificationExclusions
